import axios, { getRequestHeaders } from "./axios.js";

export const updateSql = async ({ setLoading, messageId, code }) => {
  try {
    setLoading(true);
    const response = await axios.patch(
      `/chat/message/${messageId}/update-correct-sql/`,
      {
        correct_sql: code,
      },
      {
        headers: getRequestHeaders(),
      }
    );
    setLoading(false);
    return response;
  } catch (e) {
    setLoading(false);
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";
    console.error("error : " + msg);
    return false;
  }
};
export const sendMessage = async (chatId, data) => {
  try {
    const response = await axios.post(`/chat/${chatId}/send/`, data, {
      headers: getRequestHeaders(),
    });
    return response?.data?.id;
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);

    return false;
  }
};

export const getMessageResponse = async (msgId) => {
  try {
    const response = await axios.get(`/chat/message/${msgId}/`, {
      headers: getRequestHeaders(),
    });
    return response?.data;
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);

    return false;
  }
};

export const getMessageList = async ({
  chatId,
  setLoading,
  setData,
  setError = () => {},
  limit,
  skip,
  setTotalCount = () => {},
}) => {
  setLoading?.(true);
  try {
    limit = limit || 100;
    skip = skip || 0;
    const response = await axios.get(
      `/chat/${chatId}/thread/?limit=${limit}&skip=${skip}`,
      {
        headers: getRequestHeaders(),
      }
    );
    setLoading?.(false);
    setData(response?.data?.messages);
    setTotalCount(response?.data?.total_count);
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    setLoading?.(false);
    console.error("error : " + msg);
    setError(e);
  }
};

export const setMessageReaction = async (msgId, reaction) => {
  try {
    const response = await axios.put(
      `/chat/message/${msgId}/reaction/`,
      {
        user_reaction: reaction,
      },
      {
        headers: getRequestHeaders(),
      }
    );
    return response?.data;
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);

    return false;
  }
};

export const messageFeedback = async (msgId, feedback) => {
  try {
    const response = await axios.put(
      `/chat/message/${msgId}/feedback/`,
      {
        user_feedback: feedback,
      },
      {
        headers: getRequestHeaders(),
      }
    );
    return response?.data;
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);

    return false;
  }
};

export const stopResponseGeneration = async (msgId) => {
  try {
    const response = await axios.post(
      `/chat/message/${msgId}/stop/`,
      {},
      {
        headers: getRequestHeaders(),
      }
    );
    return response?.data;
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);

    return false;
  }
};

export const reExecuteSql = async (msgId) => {
  try {
    const response = await axios.post(
      `/chat/message/${msgId}/re-execute-sql/`,
      {},
      {
        headers: getRequestHeaders(),
      }
    );
    return response?.data;
  } catch (e) {
    const msg = e?.response?.error.message ?? e?.message ?? "Unknown Error";

    console.error("error : " + msg);

    return false;
  }
};
